export class PricingComponent {
	public id: number;
	public name: string;
	public description: string;
	public isActive: boolean;
	public userId: string;
	public modifiedUserId: string;

	constructor(pricingComponent?: PricingComponent) {
		Object.assign(this, pricingComponent);
	}
}
